import {
  ApiError,
  IUserProviderState,
  GLCreateOverrides,
  PostJEResponse,
  getValidUrl,
  postRequest,
  OpsDashboardApi
} from "@jem/components";

export interface JECreateDummyFormProps {
  onSubmit: (values: GLCreateOverrides) => void;
}
export const initialState: GLCreateOverrides = {
  jeName: "",
  refNumber: "",
  companyCode: "",
  jeType: "",
  reasonCode: "",
  currency: "",
  postingDate: "",
  translationDate: "",
  reversalDate: "",
  description: "",
  jePurpose: "",
  isLongTerm: false,
  attachments: [],
  poster: "",
  backupPosters: [],
  additionalReviewers: [],
  lineItems: [],
  fiscalYear: 0,
  fiscalMonth: 0,
  preReviewers: []
};
export async function getPostDetails(
  configuration: OpsDashboardApi,
  getTokenFn: IUserProviderState["accessToken"],
  selectedAppId: string,
  payload: any
): Promise<PostJEResponse> {
  const endpoint = `${configuration.baseApiUrl}${configuration.endpoints.testPostGLJEV2}`.replace(
    "{appId}",
    `${selectedAppId}`
  );
  const apiUrl = getValidUrl(endpoint);
  const response = await postRequest<PostJEResponse>(apiUrl, payload, getTokenFn);
  if (!response) {
    throw new ApiError("No response from server");
  }
  return response;
}
export async function getValidateDetails(
  configuration: OpsDashboardApi,
  getTokenFn: IUserProviderState["accessToken"],
  selectedAppId: string,
  payload: any
): Promise<PostJEResponse> {
  const endpoint = `${configuration.baseApiUrl}${configuration.endpoints.testValidateGLJE}`.replace(
    "{appId}",
    `${selectedAppId}`
  );
  const apiUrl = getValidUrl(endpoint);
  const response = await postRequest<PostJEResponse>(apiUrl, payload, getTokenFn);
  if (!response) {
    throw new ApiError("No response from server");
  }
  return response;
}
export async function getPostDetailsFile(
  configuration: OpsDashboardApi,
  getTokenFn: IUserProviderState["accessToken"],
  selectedAppId: string,
  payload: any
): Promise<PostJEResponse> {
  const endpoint = `${configuration.baseApiUrl}${configuration.endpoints.testPostGLJEwithfileV2}`.replace(
    "{appId}",
    `${selectedAppId}`
  );
  const apiUrl = getValidUrl(endpoint);
  const response = await postRequest<PostJEResponse>(apiUrl, payload, getTokenFn);
  if (!response) {
    throw new ApiError("No response from server");
  }
  return response;
}
export async function getValidateDetailsFile(
  configuration: OpsDashboardApi,
  getTokenFn: IUserProviderState["accessToken"],
  selectedAppId: string,
  payload: any
): Promise<PostJEResponse> {
  const endpoint = `${configuration.baseApiUrl}${configuration.endpoints.testWithFileValidateGLJE}`.replace(
    "{appId}",
    `${selectedAppId}`
  );
  const apiUrl = getValidUrl(endpoint);
  const response = await postRequest<PostJEResponse>(apiUrl, payload, getTokenFn);
  if (!response) {
    throw new ApiError("No response from server");
  }
  return response;
}
